import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home/Home';
import { PrivateRoute } from './layout/PrivateRoute';
import { PublicRoute } from './layout/PublicRoute';
import Frame from './layout/Frame';
import CredMain from './pages/Cred/CredMain';
import { NotFound } from './pages/Cred/NotFound';
import { NoPermission } from './pages/Cred/NoPermission';
import { OuPreSelection } from './pages/Cred/OuPreSelection';
import { RedirectAccount } from './layout/RedirectAccount';
import { Permission } from './layout/Permission';
import { AccountDetail } from './pages/Accounts/AccountDetail';
import { Dashboard } from './pages/Accounts/Dashboard';
import { AccountRegion } from './pages/Accounts/Region';
import { Account } from './pages/Accounts/Account';
import { ProvisionForm } from './pages/Accounts/Provision';
import { InstanceDetail } from './pages/Accounts/InstanceDetail';
import { HaDetail } from './pages/Accounts/HaDetail';
import { HaCreate } from './pages/Accounts/HaCreate';
import { WebSSH } from './pages/Accounts/Webssh';
import { Group } from './pages/Group/Group';
import { GroupAccounts } from './pages/Group/GroupAccounts';
import { Retention } from '@monorepo/shared';
import { server } from './config/const';
import { Upgrade } from './pages/Accounts/Upgrade';
import { Resize } from './pages/Accounts/Resize';
import { UpgradeTicket } from './pages/Accounts/UpgradeTicket';
import { LoginRedirect } from './layout/LoginRedirect';
// import { UpgradeTicket } from './pages/Accounts/UpgradeTicket';

interface IProps {
  darkMode: boolean;
  setDarkMode: (value: boolean) => void;
}

function Routing(props: IProps) {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route element={<PublicRoute />}>
            <Route path="/" element={<Home />} {...props} />
          </Route>
          <Route
            path="/login-redirect"
            element={<LoginRedirect />}
            {...props}
          />
          <Route path="/permission" element={<Permission />} {...props} />
          <Route element={<PrivateRoute />}>
            <Route element={<RedirectAccount />}>
              <Route
                path="/group"
                element={
                  <Frame {...props}>
                    <Group />
                  </Frame>
                }
              >
                <Route path="accounts/:groupId?" element={<GroupAccounts />} />
                <Route
                  path="accounts/:groupId/:accountId"
                  element={<AccountDetail />}
                />
                <Route
                  path="accounts/:groupId/:accountId/region/:regionId"
                  element={<AccountRegion />}
                />
                {/* <Route
                  path="accounts/:groupId/account/:accountId/provision/:sn/:regionId?"
                  element={<ProvisionForm />}
                /> */}
                <Route
                  path="accounts/:groupId/:accountId/ha/create"
                  element={<HaCreate />}
                />
                <Route
                  path="accounts/:groupId/:accountId/region?/:regionId?/ha/:haId"
                  element={<HaDetail />}
                />
                <Route
                  path="accounts/:groupId/:accountId/region?/:regionId?/ha/:haId/edit"
                  element={<HaCreate />}
                />
                <Route
                  path="accounts/:groupId/:accountId/region?/:regionId?/ha?/:haId?/instance/:instanceId"
                  element={<InstanceDetail />}
                />
                <Route
                  path="accounts/:groupId/:accountId/region?/:regionId?/ha?/:haId?/instance/:instanceId/ticket"
                  element={<UpgradeTicket />}
                />
              </Route>
            </Route>
          </Route>
          <Route element={<PrivateRoute />}>
            <Route element={<RedirectAccount />}>
              <Route
                path="/organization"
                element={
                  <Frame {...props}>
                    <Account />
                  </Frame>
                }
              >
                <Route path=":accountId" element={<AccountDetail />} />
                <Route
                  path=":accountId/region/:regionId"
                  element={<AccountRegion />}
                />
                <Route
                  path=":accountId/provision/:sn/:regionId?"
                  element={<ProvisionForm />}
                />
                <Route path=":accountId/ha/create" element={<HaCreate />} />
                <Route
                  path=":accountId/region?/:regionId?/ha/:haId"
                  element={<HaDetail />}
                />
                <Route
                  path=":accountId/region?/:regionId?/ha/:haId/edit"
                  element={<HaCreate />}
                />
                <Route
                  path=":accountId/region?/:regionId?/ha?/:haId?/instance/:instanceId"
                  element={<InstanceDetail />}
                />
                <Route
                  path=":accountId/region?/:regionId?/ha?/:haId?/instance/:instanceId/upgrade"
                  element={<Upgrade />}
                />
                <Route
                  path=":accountId/region?/:regionId?/ha?/:haId?/instance/:instanceId/resize"
                  element={<Resize />}
                />
                <Route
                  path=":accountId/region?/:regionId?/ha?/:haId?/instance/:instanceId/ticket"
                  element={<UpgradeTicket />}
                />
              </Route>
            </Route>
          </Route>
          <Route element={<PrivateRoute />}>
            <Route element={<RedirectAccount />}>
              <Route
                path="/cred"
                element={
                  <Frame {...props} hideSideMenu>
                    <CredMain />
                  </Frame>
                }
                // {...props}
              >
                <Route path="no-permission" element={<NoPermission />} />
                <Route path="*" element={<OuPreSelection />} />
              </Route>
            </Route>
          </Route>
          <Route element={<PrivateRoute />}>
            <Route
              path="/webssh"
              element={
                <Frame {...props} hideSideMenu hideHeader hideFooter>
                  {/* <Webssh /> */}
                  <WebSSH />
                </Frame>
              }
              {...props}
            />
          </Route>
          <Route element={<PrivateRoute />}>
            <Route
              path="/vm-retention"
              element={
                <Frame {...props} hideSideMenu>
                  <Retention server={server} />
                </Frame>
              }
              {...props}
            />
          </Route>
          <Route path="*" element={<NotFound />}></Route>
        </Routes>
      </Router>
    </div>
  );
}

export default Routing;
